import React, { useEffect, useState } from 'react'
import { Button, Chip, Grid, Paper, Stack, Typography } from '@mui/material'
import { LocalPolice, ReportProblem } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import API from '../../../services/API'

// Home-screen strip shown when the user is crewed on a CAD resource in a
// live control room — same source as the mobile app's resource card, so it
// appears as soon as a dispatcher crews them, clocked in or not. Renders
// nothing otherwise (mirrors ActiveShift).
const ActiveResourceCard = () => {
  const navigate = useNavigate()
  const [activeResource, setActiveResource] = useState(null)

  useEffect(() => {
    const load = () =>
      API.get('/mobile/command/my-active-resource')
        .then((res) => {
          if (res.status === 200) {
            setActiveResource(res.data?.activeResource ?? null)
          }
        })
        .catch((e) => console.log(e))
    load()
    const interval = setInterval(load, 60000)
    return () => clearInterval(interval)
  }, [])

  if (!activeResource?.resource) return null

  const { resource, controlRoom, incident } = activeResource
  const roomName =
    controlRoom?.title || controlRoom?.event?.title || 'Control room'
  const crewCount = (resource.users ?? []).length

  return (
    <Grid item xs={12}>
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 4,
          p: 2,
          borderLeft: '6px solid #239AA4',
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ sm: 'center' }}
          spacing={1.5}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <LocalPolice sx={{ color: '#239AA4' }} />
            <Stack>
              <Typography fontWeight={900} color="#242F40">
                Your Resource — {resource.callSign}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {roomName}
                {crewCount > 1
                  ? ` · Crew of ${crewCount}`
                  : ' · Solo resource'}
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Chip
              size="small"
              label={resource.status}
              sx={{ borderRadius: 999, fontWeight: 800 }}
            />
            {incident && (
              <Chip
                size="small"
                icon={<ReportProblem sx={{ fontSize: 16 }} />}
                label={`Tasking: ${incident.status}`}
                sx={{
                  borderRadius: 999,
                  fontWeight: 800,
                  backgroundColor: '#FEE2E2',
                  color: '#991B1B',
                }}
              />
            )}
            <Button
              variant="contained"
              onClick={() => navigate('/my-resource')}
              sx={{
                borderRadius: 999,
                textTransform: 'none',
                fontWeight: 900,
                backgroundColor: '#239AA4',
                '&:hover': { backgroundColor: '#1E7F88' },
              }}
            >
              Open Resource
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Grid>
  )
}

export default ActiveResourceCard
